import { ButtonHTMLAttributes, MouseEventHandler, PropsWithChildren, forwardRef } from 'react';
import { tv } from 'tailwind-variants';

const cardButtonTV = tv({
  base: 'outline-0 transition-all duration-300 ease-in-out focus:outline-none focus-visible:ring-1 focus-visible:ring-other-outline focus-visible:ring-offset-2',
});

export type CardButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

/**
 * children を受け取れる単発アクションボタン。
 * ナビゲーション行・添付クリック・FAB 子ボタン等、リッチコンテンツのクリック領域向け。
 * トグル選択は ToggleCardButton、ラベル+アイコンのみは Button / IconButton を使う。
 */
export const CardButton = forwardRef<HTMLButtonElement, PropsWithChildren<CardButtonProps>>(
  ({ type = 'button', className, children, onMouseDown, ...props }, ref) => {
    // マウス押下ではフォーカスを当てず focus-visible リングを抑制（キーボードのフォーカスは従来どおりでリング維持）
    const handleMouseDown: MouseEventHandler<HTMLButtonElement> = (e) => {
      onMouseDown?.(e);
      e.preventDefault();
    };
    return (
      <button ref={ref} type={type} className={cardButtonTV({ className })} {...props} onMouseDown={handleMouseDown}>
        {children}
      </button>
    );
  }
);
CardButton.displayName = 'CardButton';
